import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Beranda from "@/pages/Beranda";
import TentangKami from "@/pages/TentangKami";
import GaleriFoto from "@/pages/GaleriFoto";
import JurnalArtikel from "@/pages/JurnalArtikel";
import ArtikelDetail from "@/pages/ArtikelDetail";
import InformasiPendaftaran from "@/pages/InformasiPendaftaran";
import FasilitasSekolah from "@/pages/FasilitasSekolah";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider, useSettings } from "@/context/SettingsContext";
import "@/App.css";

// Kode FloatingWA tetap ada tapi disembunyikan (display:none)
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function FloatingWA() {
  const { waUrl } = useSettings();
  return (
    <a
      href={waUrl}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-wa-button"
      className="fixed bottom-24 right-6 z-50 inline-flex items-center gap-2 text-white pl-4 pr-5 py-3 rounded-full shadow-2xl transition-all duration-300 hover:scale-105"
      style={{ backgroundColor: "#25d366", display: "none" }}
      title="Hubungi via WhatsApp"
    >
      <MessageCircle size={22} />
      <span className="font-bold text-sm">Hubungi WA</span>
    </a>
  );
}

function PublicLayout({ children }) {
  return (
    <>
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
      <FloatingWA />
    </>
  );
}

function AppShell() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  if (isAdmin) {
    return (
      <Routes>
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
    );
  }

  return (
    <div className="min-h-screen flex flex-col" style={{ fontFamily: "'Nunito', sans-serif", backgroundColor: "#F8FAF8" }}>
      <ScrollToTop />
      <PublicLayout>
        <Routes>
          <Route path="/" element={<Beranda />} />
          <Route path="/tentang-kami" element={<TentangKami />} />
          <Route path="/galeri-foto" element={<GaleriFoto />} />
          <Route path="/jurnal" element={<JurnalArtikel key="jurnal" defaultTab="jurnal" />} />
          <Route path="/artikel" element={<JurnalArtikel key="artikel" defaultTab="artikel" />} />
          <Route path="/artikel/:id" element={<ArtikelDetail />} />
          <Route path="/informasi-pendaftaran" element={<InformasiPendaftaran />} />
          <Route path="/fasilitas-sekolah" element={<FasilitasSekolah />} />
        </Routes>
      </PublicLayout>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <SettingsProvider>
        <BrowserRouter>
          <AppShell />
        </BrowserRouter>
      </SettingsProvider>
    </AuthProvider>
  );
}

export default App;
